import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { setMoneyRate } from "@/lib/money";

const CurrencyContext = createContext(null);

export function CurrencyProvider({ children }) {
  const [rate, setRate] = useState(1);
  const [rateMeta, setRateMeta] = useState({ source: null, date: null, bnr: null });

  const apply = useCallback((data) => {
    const r = data.ron_per_eur || 1;
    setMoneyRate(r);
    setRate(r);
    setRateMeta({ source: data.source, date: data.date, bnr: data.bnr_ron_per_eur, bnrDate: data.bnr_date });
  }, []);

  const reload = useCallback(() => api.get("/exchange-rate").then(({ data }) => apply(data)).catch(() => {}), [apply]);

  useEffect(() => { reload(); }, [reload]);

  return (
    <CurrencyContext.Provider value={{ rate, rateMeta, apply, reload }}>
      {children}
    </CurrencyContext.Provider>
  );
}

export const useCurrency = () => useContext(CurrencyContext);
